import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "customRouteTimePickerComponentContent" }
const _hoisted_2 = {
  key: 0,
  class: "input-time-position"
}
const _hoisted_3 = {
  key: 0,
  class: "custom-route-time-modal-mask"
}
const _hoisted_4 = { class: "modal-wrapper" }
const _hoisted_5 = { class: "modal-content" }
const _hoisted_6 = { class: "modal-header justify-content-end" }
const _hoisted_7 = { class: "modal-body d-flex align-items-center" }
const _hoisted_8 = { class: "customRouteTimePickerModalText" }
const _hoisted_9 = { class: "m-0 pe-3" }
const _hoisted_10 = { class: "customRouteTimePickerModalInput" }
const _hoisted_11 = ["value"]
const _hoisted_12 = ["value"]
const _hoisted_13 = ["value"]
const _hoisted_14 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _mergeProps({
      class: "customRouteTimePickerComponent",
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleModal(true)))
    }, _ctx.$attrs), [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.arrivalTime)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.customRouteFullTime.split(':')[0].trim() + ':' + _ctx.customRouteFullTime.split(':')[1].trim()), 1))
          : _createCommentVNode("", true)
      ]),
      (_ctx.timePickerModal)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "custom-route-close-button",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.closeModal(false)), ["stop"]))
                  }, _cache[5] || (_cache[5] = [
                    _createElementVNode("span", { "aria-hidden": "true" }, "×", -1)
                  ]))
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("h5", _hoisted_9, _toDisplayString(_ctx.$t('time')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("select", {
                      value: _ctx.currentHours.length === 1 ? '0' + _ctx.currentHours : _ctx.currentHours,
                      onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.changeHours && _ctx.changeHours(...args)))
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hours, (hour) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: hour,
                          key: hour
                        }, _toDisplayString(hour), 9, _hoisted_12))
                      }), 128))
                    ], 40, _hoisted_11),
                    _cache[6] || (_cache[6] = _createElementVNode("span", null, ":", -1)),
                    _createElementVNode("select", {
                      value: _ctx.currentMinutes.length === 1 ? '0' + _ctx.currentMinutes : _ctx.currentMinutes,
                      onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.changeMinutes && _ctx.changeMinutes(...args)))
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.minutes, (minute) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: minute,
                          key: minute
                        }, _toDisplayString(minute), 9, _hoisted_14))
                      }), 128))
                    ], 40, _hoisted_13)
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ], 16),
    (_ctx.timePickerModal)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          id: "closeCustomRouteTimepickerModal",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.closeModal(false)))
        }))
      : _createCommentVNode("", true)
  ], 64))
}